module.exports = __webpack_public_path__ + "img/icon175.5a4fe151.png";